import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
	selector: '[uiButtonToggleContent]',
})
export class ButtonToggleContentDirective {
	public templateRef: TemplateRef<any> = inject(TemplateRef);
}
